// extracted by mini-css-extract-plugin
export default {"gameWr":"QuizProverb_gameWr__9qtau","game":"QuizProverb_game__2b5og","result":"QuizProverb_result__egyXa","gameMobile":"QuizProverb_gameMobile__0FPXC"};